import { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Icon from '../../../shared/components/Icon';
import { changePasswordApi } from '../../../api/ismApi';
import '../../../styles/common.css';
import '../../../styles/modal.css';
import '../../../styles/forms.css';
import '../styles/changePassword.css';

export default function ChangePasswordModal({ onClose, onLogout }) {
  const [form, setForm]       = useState({ old_password: '', new_password: '', confirm_new_password: '' });
  const [showPwd, setShowPwd] = useState({ old: false, new: false, confirm: false });
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState(false);
  const [saving, setSaving]   = useState(false);
  const timerRef = useRef(null);
  useEffect(() => () => clearTimeout(timerRef.current), []);

  const update = (field, value) => setForm(f => ({ ...f, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.new_password.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }
    if (form.new_password !== form.confirm_new_password) {
      setError('New passwords do not match.');
      return;
    }

    setSaving(true);
    try {
      const res = await changePasswordApi(form);
      if (res && res.status_code === 200) {
        setSuccess(true);
        timerRef.current = setTimeout(() => {
          if (onLogout) onLogout();
        }, 1500);
      } else {
        setError('Failed to change password.');
      }
    } catch (err) {
      setError(err.message || 'Failed to change password.');
    } finally {
      setSaving(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-panel pwd-modal">
        {/* Header */}
        <div className="modal-header">
          <span className="modal-header__title">Change password</span>
          <button className="modal-header__close" onClick={onClose}>
            <Icon name="x" size={16} />
          </button>
        </div>

        {success ? (
          <div className="modal-body">
            <div className="pwd-modal__success">
              <Icon name="check" size={18} stroke={2.5} />
              Password changed successfully.
            </div>
            <button className="btn-primary w-full flex-center mt-8" onClick={onClose}>
              Close
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="modal-body">
            {[
              { key: 'old_password',         label: 'Current password',  show: showPwd.old,     toggle: () => setShowPwd(s => ({ ...s, old: !s.old })) },
              { key: 'new_password',         label: 'New password',      show: showPwd.new,     toggle: () => setShowPwd(s => ({ ...s, new: !s.new })) },
              { key: 'confirm_new_password', label: 'Confirm password',  show: showPwd.confirm, toggle: () => setShowPwd(s => ({ ...s, confirm: !s.confirm })) },
            ].map(({ key, label, show, toggle }) => (
              <div key={key} className="pwd-field">
                <label className="pwd-field__label">{label}</label>
                <div className="pwd-field__wrap">
                  <input
                    type={show ? 'text' : 'password'}
                    value={form[key]}
                    onChange={e => update(key, e.target.value)}
                    required
                    className="pwd-field__input"
                    placeholder="••••••••"
                  />
                  <button type="button" className="pwd-field__toggle" onClick={toggle} tabIndex={-1}>
                    <Icon name={show ? 'eye-off' : 'eye'} size={15} />
                  </button>
                </div>
              </div>
            ))}

            {error && <div className="error-box">{error}</div>}

            <div className="pwd-modal__btn-row">
              <button type="button" className="btn-ghost-sm pwd-modal__btn" onClick={onClose}>
                Cancel
              </button>
              <button
                type="submit"
                className="btn-primary pwd-modal__btn"
                disabled={saving}
              >
                {saving ? <span className="spinner" style={{ width: 12, height: 12 }} /> : 'Save'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>,
    document.querySelector('.app') || document.body
  );
}